import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { PessoaWhitelabelModel } from 'model/api/gestao/pessoa/pessoa-whitelabel-model';
import { PessoaTaxaPostModel } from 'model/api/gestao/pessoa-taxa/pessoa-taxa-post-model';

export function usePutPessoaTaxa() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<PessoaWhitelabelModel>();

    const putPessoaTaxa = useCallback(
        (pessoaId: string, model: PessoaTaxaPostModel) =>
            invocarApi({
                method: 'PUT',
                url: `/${VariaveisAmbiente.apiVersion}/pessoa/${pessoaId}/taxas`,
                data: model,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putPessoaTaxa,
    };
}